module.exports = __webpack_public_path__ + "static/media/regular.c9f05d33.pdf";